import { useState } from 'react';

export default function TrendingProjects() {
  const [activeFilter, setActiveFilter] = useState('All');
  
  const filters = ['All', 'Beauty', 'Tech', 'Fashion', 'Lifestyle'];

  const projects = [
    {
      image: 'https://readdy.ai/api/search-image?query=woman%20applying%20serum%20to%20face%20looking%20at%20camera%20with%20genuine%20smile%20in%20bathroom%20setting%20natural%20morning%20light%20skincare%20routine%20ugc%20content%20authentic%20relatable&width=360&height=640&seq=work1&orientation=portrait',
      title: 'Skincare Routine Series',
      brand: 'GlowBeauty',
      category: 'Beauty',
      type: 'UGC Video',
      results: '450K views • 12% CTR'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=hands%20holding%20wireless%20earbuds%20showing%20features%20to%20camera%20on%20desk%20setup%20with%20laptop%20tech%20review%20style%20natural%20lighting%20authentic%20ugc%20content&width=360&height=640&seq=work2&orientation=portrait',
      title: 'Earbuds Review',
      brand: 'TechNova',
      category: 'Tech',
      type: 'Product Demo',
      results: '380K views • 3.2x ROAS'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=woman%20trying%20on%20clothes%20in%20front%20of%20mirror%20showing%20outfit%20details%20fashion%20haul%20style%20bedroom%20setting%20natural%20daylight%20authentic%20ugc%20creator%20content&width=360&height=640&seq=work3&orientation=portrait',
      title: 'Summer Haul',
      brand: 'UrbanStyle',
      category: 'Fashion',
      type: 'Try-On Haul',
      results: '520K views • 18% engagement'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=woman%20preparing%20healthy%20smoothie%20in%20kitchen%20showing%20supplement%20powder%20to%20camera%20wellness%20lifestyle%20content%20bright%20modern%20kitchen%20natural%20lighting&width=360&height=640&seq=work4&orientation=portrait',
      title: 'Morning Routine',
      brand: 'PureLife',
      category: 'Lifestyle',
      type: 'Lifestyle Content',
      results: '290K views • 2.8x ROAS'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=close%20up%20hands%20applying%20lipstick%20looking%20at%20compact%20mirror%20beauty%20tutorial%20style%20soft%20lighting%20makeup%20application%20authentic%20ugc%20content&width=360&height=640&seq=work5&orientation=portrait',
      title: 'Lipstick Launch',
      brand: 'BeautyBox',
      category: 'Beauty',
      type: 'Product Review',
      results: '610K views • 15% CTR'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=woman%20unboxing%20package%20excited%20reaction%20showing%20phone%20case%20to%20camera%20in%20living%20room%20setting%20natural%20daylight%20authentic%20ugc%20unboxing%20content&width=360&height=640&seq=work6&orientation=portrait',
      title: 'Accessories Unboxing',
      brand: 'SmartGear',
      category: 'Tech',
      type: 'Unboxing',
      results: '410K views • 4.1x ROAS'
    }
  ];

  const filteredProjects = activeFilter === 'All' 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  return (
    <section id="portfolio" className="py-16 md:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <div className="text-xs uppercase tracking-widest text-amber-700 mb-3 md:mb-4">My Work</div>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-3 md:mb-4">
            Portfolio & <span className="font-light italic">Results</span>
          </h2>
          <p className="text-base md:text-lg text-stone-500 max-w-2xl mx-auto px-4">
            A selection of my recent brand collaborations and the results they achieved
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="flex items-center justify-start md:justify-center gap-2 mb-8 md:mb-12 overflow-x-auto px-4 pb-2 scrollbar-hide">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={`px-4 md:px-5 py-2 rounded-full text-xs md:text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex-shrink-0 ${
                activeFilter === filter
                  ? 'bg-stone-900 text-white'
                  : 'bg-white text-stone-600 hover:bg-stone-100'
              }`}
            >
              {filter}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-6">
          {filteredProjects.map((project, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl md:rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full" style={{ aspectRatio: '9/16' }}>
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* Play button - always visible */}
                <div className="absolute inset-0 flex items-center justify-center transition-opacity duration-300 group-hover:opacity-100 opacity-70">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-white/90 rounded-full flex items-center justify-center shadow-lg">
                    <i className="ri-play-fill text-2xl md:text-3xl text-stone-900 ml-1"></i>
                  </div>
                </div>

                {/* Type badge */}
                <div className="absolute top-2 md:top-4 left-2 md:left-4">
                  <span className="bg-white/90 backdrop-blur-sm px-2 md:px-3 py-1 rounded-full text-xs font-medium text-stone-800">
                    {project.type}
                  </span>
                </div>
              </div>
              
              <div className="p-4 md:p-6">
                <div className="flex items-center gap-2 mb-1 md:mb-2">
                  <span className="text-xs text-amber-700 font-medium">{project.brand}</span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-stone-900 mb-1 md:mb-2">{project.title}</h3>
                <div className="flex items-center gap-2 text-xs md:text-sm text-stone-500">
                  <i className="ri-bar-chart-line text-green-600"></i>
                  <span>{project.results}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-12 px-4">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-stone-900 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-medium hover:bg-stone-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Request Full Portfolio
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
